import React, { Component } from 'react';

class Gallery extends Component {
  render() {
    const { photos, onSelect } = this.props;
    const photoLinks = Object.entries(photos);

    const childElements = photoLinks.map((entry, index) => {
      const photo = entry[0];
      const src = entry[1];
      return (
        <span key={`${photo}:${index}`} onClick={() => onSelect(photo, src)}>
          <img src={src} alt="" className="gallery-image" />
        </span>
      );
    });

    return (
      <div className="flexbin flexbin-margin gallery">{childElements}</div>
    );
  }
}

export default Gallery;
